/* eslint-disable prettier/prettier */
import clock from '@images/custom/clock.svg';
import '@root/scss/default/main.scss';
import { useNavigate } from 'react-router-dom';

const CustomProcessing = () => {
  useNavigate();

  return (
    <section className={'infoScreen'}>
      <img src={clock} alt="clock icons" className="clock-img-box__img" />
      <p>Транзакция в обработке</p>
    </section>
  );
};
export default CustomProcessing;
